var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.isPresentation)?_c('span',{staticClass:"menu-title"},[_vm._v("\n  "+_vm._s(_vm.props.text)+"\n")]):_c('a',_vm._g(_vm._b({staticClass:"menu-title",attrs:{"href":_vm.props.url}},'a',_vm.data.attrs,false),_vm.listeners),[_vm._v("\n  "+_vm._s(_vm.props.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }